import { defineStore } from 'pinia';

export const useSubscriptionStore = defineStore('subscriptionStore', {
  state: () => ({
    showSubscriptionModal: false as boolean,
    issueType: '' as 'templates' | 'members' | 'versions' | ''
  }),
  getters: {
    subscriptionMessage: (state) => {
      const messages: Record<string, string> = {
        templates: 'Need Premium to add more templates',
        members: 'Need Pro to add another member',
        versions: 'Need Premium to create more versions'
      };
      return messages[state.issueType] || '';
    }
  },
  actions: {
    openSubscriptionModal(type: 'templates' | 'members' | 'versions') {
      this.issueType = type;
      this.showSubscriptionModal = true;
    },
    resetSubscriptionModal() {
      this.issueType = '';
      this.showSubscriptionModal = false;
    }
  }
});
